import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useSelector } from 'react-redux'
import { PDFDownloadLink } from '@react-pdf/renderer'

import { Checkbox, CircularProgress, FormControlLabel } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

import moment from 'moment'
import 'moment/locale/es'

import NumberFormat from 'react-number-format'

import './vistaPrevia.css'
import './headers.css'
import './cliente.css'

import { fetchConTokenFilePDFBuffer } from '../../../helpers/fetch'
import { Model } from '../../../models/model'
import { PdfFile } from './PdfFile'

import imgRejilla from './rejilla.svg'
import { VistaPreviaPrint } from './VistaPreviaPrint'
import { HeaderLogoLeft } from './HeaderLogoLeft';
import { HeaderLogoRight } from './HeaderLogoRight';

import imgFirma from '../../../assets/firmas/firmaID22.png'

const VistaPrevia = ({ open, setOpen }) => {

    const auth = useSelector(state => state.auth)
    const infoEmp = useSelector(state => state.general.info)
    const infoGeneral = useSelector(state => state.general.detail)

    const {
        nombre_columna_dias, pdf_color_formato, pdf_header_logo_izq, ppto_ocultar_tc,
        imp_venta_nombre, modo_arquitectura, ppto_pdf_mostrar_firma = false,
        texto_no_incluye_igv
    } = infoGeneral

    const { url_foto } = infoEmp

    const dataPreview = useSelector(state => state.ppto.detail)

    const [openPrint, setOpenPrint] = useState(false)
    const [openPreviewOptions, setOpenPreviewOptions] = useState(false)
    const [progressDownload, setProgressDownload] = useState(false)
    const [progressPrint, setProgressPrint] = useState(false)
    const [urlPDF, setUrlPDF] = useState('')

    let fileNamePdf = `ppto_${dataPreview.referencia}_v${dataPreview?.nro_version_actual || '1'}_.pdf`
    fileNamePdf = (fileNamePdf.replaceAll(/ /gi, '_')).toLowerCase()

    const [viewOptions, setViewOptions] = useState({
        ocultar_montos_items: false,
        ver_solo_subtotal_item: false,
        ver_solo_subtotal_titulos: false,
        ver_solo_titulos: false,
        ver_total_con_impuestos: true,
        ocultar_texto_igv: false,
        mostrar_firma: false
    })

    const params = useParams()
    const { budgetId: idPresupuesto } = params

    const { separacion_miles, separacion_decimales, simbolo, sub_total, descuento, total_cliente, forma_pago, fecha_vencimiento, observaciones, total, total_impuesto, porcentaje_impuesto, descuento_porcentaje, validacion_estado, no_incluye, moneda, terminos_condiciones, sobrecargo_gg, sobrecargo_gg_porcentaje, sobrecargo_utilidad, sobrecargo_utilidad_porcentaje, id_tipo_documento } = dataPreview

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    const { current: descriptionElement } = descriptionElementRef;

    useEffect(() => {
        if (open) {
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open, descriptionElement]);

    const handleDowload = async () => {
        setProgressDownload(true)

        const url = await getUrlPDF()
        setUrlPDF(url)

        await Model.save({
            url: 'ppto_versiones',
            dataForm: {
                id_ppto: idPresupuesto,
                data_version: JSON.stringify(dataPreview)
            }
        })

        document.getElementById('btn-descargar-pdf').click()


        setProgressDownload(false)
    }

    const handlePrint = async () => {
        setProgressPrint(true)

        const url = await getUrlPDF()
        setUrlPDF(url)

        setProgressPrint(false)
        setOpenPrint(true)
    }

    const getUrlPDF = async () => {
        try {

            // const params = (new URLSearchParams(filters)).toString()
            // const fileName = `contactos_${new Date()}_`
            const resp = await fetchConTokenFilePDFBuffer(`budgets/dowload_pdf/${idPresupuesto}`, {}, 'GET')
            return resp.url

            // if (body.ok) {
            //     return body.data || null
            // } else {
            //     toast.error('Lo sentimos, ocurrió un error')
            //     return null
            // }

        } catch (error) {
            console.log(error)
            // toast.error(error)
        }
    }

    return (
        <div>
            <Dialog
                className='ContainerModalVistaPrevia'
                open={open}
                onClose={handleClose}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle
                    className='ColorTitleDocument'
                    id="scroll-dialog-title">

                    <div>
                        <label> Vista previa</label>
                        <img className='p-buscar-filtros' src={imgRejilla} alt="filtros"
                            style={{ marginLeft: '10px' }}
                            onClick={() => (setOpenPreviewOptions(!openPreviewOptions))}
                        />
                    </div>

                    <IconButton
                        aria-label="close"
                        style={{ padding: '0', float: 'right' }}
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon style={{ color: '#78667E' }} />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers className='DialogContentVistaPrevia'>

                    {openPreviewOptions &&
                        <PreviewOptions
                            viewOptions={viewOptions}
                            setViewOptions={setViewOptions}
                            imp_venta_nombre={imp_venta_nombre}
                            ppto_pdf_mostrar_firma={ppto_pdf_mostrar_firma}
                        />
                    }

                    {(validacion_estado === 'por validar' || validacion_estado === 'rechazada' || validacion_estado === 'solicitado') &&
                        < div className='copia-no-valida'>
                            <h2>Copia no válida</h2>
                            <h3>(presupuesto pendiente de validar)</h3>
                        </div>
                    }

                    <div className={(validacion_estado === 'por validar' || validacion_estado === 'rechazada' || validacion_estado === 'solicitado') ? 'ContainerPresupuestoSinValidar' : 'ContainerPresupuesto'}>

                        {pdf_header_logo_izq ?
                            <HeaderLogoLeft
                                infoEmp={infoEmp}
                                infoGeneral={infoGeneral}
                                dataPreview={dataPreview}
                            />
                            :
                            <HeaderLogoRight
                                infoEmp={infoEmp}
                                infoGeneral={infoGeneral}
                                dataPreview={dataPreview}
                            />
                        }

                        <DatosClientes
                            dataPreview={dataPreview}
                            auth={auth}
                            infoGeneral={infoGeneral}
                        />

                        <section className='Section2Presupuesto'>
                            <section>
                                <h1 className='ColorTitleDocument p-vp-referencia'>{dataPreview.referencia}</h1>

                                {modo_arquitectura &&
                                    <div className='cliente-pdf-2 d-flex flex-column mt-2'>
                                        {dataPreview?.ubicacion ?
                                            <div className='d-flex justify-content-start align-items-center'>
                                                <p className='label'>Ubicación: </p>
                                                <p className='data' style={{ marginLeft: '20px' }}>{dataPreview?.ubicacion || '--'}</p>
                                            </div> : ''
                                        }
                                        {dataPreview?.area_construida ?
                                            <div className='d-flex justify-content-start align-items-center'>
                                                <p className='label'>Área: </p>
                                                <p className='data' style={{ marginLeft: '45px' }}>
                                                    {dataPreview?.area_construida || '--'}{' '}{dataPreview?.medida_construida || 'MT2'}
                                                </p>
                                            </div> : ''
                                        }
                                    </div>
                                }

                                <section className='InfoGeneralPpto'>

                                    <TablaPresupuesto
                                        dataPreview={dataPreview}
                                        viewOptions={viewOptions}
                                        nombre_columna_dias={nombre_columna_dias}
                                    />

                                    <section className='row InfoFinalPpto'>

                                        <div className='col-7'></div>
                                        <div className='col-5 p-bloque-total'>

                                            {(descuento > 0 || (sobrecargo_gg_porcentaje > 0 || sobrecargo_utilidad_porcentaje > 0)) &&
                                                <div className='row'>
                                                    <div className='col-6'><label className='p-label-total'>SUBTOTAL</label></div>
                                                    <div className='col-6'>
                                                        <NumberFormat
                                                            className='p-label-total-monto'
                                                            value={sub_total}
                                                            displayType={'text'}
                                                            thousandSeparator={separacion_miles}
                                                            decimalSeparator={separacion_decimales}
                                                            prefix={`${simbolo} `}
                                                            decimalScale={2}
                                                            fixedDecimalScale
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            {descuento > 0 &&
                                                <div className='row'>
                                                    <div className='col-6'>
                                                        <label className='p-label-total'>
                                                            ( {descuento_porcentaje}% )<span className='ms-2'>DSCTO.</span>
                                                        </label>
                                                    </div>
                                                    <div className='col-6'>
                                                        <NumberFormat
                                                            className='p-label-total-monto'
                                                            value={descuento}
                                                            displayType={'text'}
                                                            thousandSeparator={separacion_miles}
                                                            decimalSeparator={separacion_decimales}
                                                            prefix={`${simbolo} `}
                                                            decimalScale={2}
                                                            fixedDecimalScale
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            {/* === NEW SUBTOTAL CON DESCUENTO */}
                                            {descuento > 0 &&
                                                <div className='row'>
                                                    <div className='col-6'>
                                                        <label className='p-label-total'>
                                                            <span className='ms-2'>SUBTOTAL CON DSCTO.</span>
                                                        </label>
                                                    </div>
                                                    <div className='col-6'>
                                                        <NumberFormat
                                                            className='p-label-total-monto'
                                                            value={(sub_total - descuento)}
                                                            displayType={'text'}
                                                            thousandSeparator={separacion_miles}
                                                            decimalSeparator={separacion_decimales}
                                                            prefix={`${simbolo} `}
                                                            decimalScale={2}
                                                            fixedDecimalScale
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            {/* === SOBRECARGOS */}
                                            {sobrecargo_gg_porcentaje > 0 &&
                                                <div className='row mt-2'>
                                                    <div className='col-6'>
                                                        <label className='p-label-total'>
                                                            Gastos Generales ({sobrecargo_gg_porcentaje}%)
                                                        </label>
                                                    </div>
                                                    <div className='col-6'>
                                                        <NumberFormat
                                                            className='p-label-total-monto'
                                                            value={sobrecargo_gg}
                                                            displayType={'text'}
                                                            thousandSeparator={separacion_miles}
                                                            decimalSeparator={separacion_decimales}
                                                            prefix={`${simbolo} `}
                                                            decimalScale={2}
                                                            fixedDecimalScale
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            {sobrecargo_utilidad_porcentaje > 0 &&
                                                <div className='row mb-2'>
                                                    <div className='col-6'>
                                                        <label className='p-label-total'>
                                                            Utilidad ({sobrecargo_utilidad_porcentaje}%)
                                                        </label>
                                                    </div>
                                                    <div className='col-6'>
                                                        <NumberFormat
                                                            className='p-label-total-monto'
                                                            value={sobrecargo_utilidad}
                                                            displayType={'text'}
                                                            thousandSeparator={separacion_miles}
                                                            decimalSeparator={separacion_decimales}
                                                            prefix={`${simbolo} `}
                                                            decimalScale={2}
                                                            fixedDecimalScale
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            {/* === SOBRECARGOS */}

                                            <div className='row'>
                                                <div className='col-6'>
                                                    <label className='p-label-total2'>
                                                        {viewOptions.ocultar_texto_igv ? 'TOTAL' : 'TOTAL NETO'}
                                                    </label>
                                                </div>
                                                <div className='col-6 p-total-base'>
                                                    <NumberFormat
                                                        className='p-label-total-monto2'
                                                        value={total_cliente}
                                                        displayType={'text'}
                                                        thousandSeparator={separacion_miles}
                                                        decimalSeparator={separacion_decimales}
                                                        prefix={`${simbolo} `}
                                                        decimalScale={2}
                                                        fixedDecimalScale
                                                    />
                                                </div>
                                            </div>

                                            {viewOptions.ver_total_con_impuestos &&
                                                <>
                                                    <div className='row'>
                                                        <div className='col-6'>
                                                            {parseInt(id_tipo_documento) === 4 ?
                                                                <label className='p-label-total'>
                                                                    ( {porcentaje_impuesto}% )<span className='ms-2'>IR</span>
                                                                </label>
                                                                :
                                                                <label className='p-label-total'>
                                                                    ( {porcentaje_impuesto}% )<span className='ms-2'>{imp_venta_nombre?.toUpperCase() || 'IGV'}</span>
                                                                </label>
                                                            }
                                                        </div>
                                                        <div className='col-6'>
                                                            <NumberFormat
                                                                className='p-label-total-monto'
                                                                value={total_impuesto}
                                                                displayType={'text'}
                                                                thousandSeparator={separacion_miles}
                                                                decimalSeparator={separacion_decimales}
                                                                prefix={`${simbolo} `}
                                                                decimalScale={2}
                                                                fixedDecimalScale
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row'>
                                                        <div className='col-6'><label className='p-label-total'>TOTAL</label></div>
                                                        <div className='col-6'>
                                                            <NumberFormat
                                                                className='p-label-total-monto'
                                                                value={total}
                                                                displayType={'text'}
                                                                thousandSeparator={separacion_miles}
                                                                decimalSeparator={separacion_decimales}
                                                                prefix={`${simbolo} `}
                                                                decimalScale={2}
                                                                fixedDecimalScale
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            }

                                            {(!viewOptions.ver_total_con_impuestos && !viewOptions.ocultar_texto_igv) &&
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        {(texto_no_incluye_igv && !texto_no_incluye_igv !== '') ?
                                                            <p className='label-igv'>{texto_no_incluye_igv || 'IGV'}</p>
                                                            :
                                                            <p className='label-igv'>No incluye {imp_venta_nombre?.toUpperCase() || 'IGV'}</p>
                                                        }
                                                    </div>
                                                </div>
                                            }

                                        </div>

                                    </section>
                                </section>
                            </section>
                        </section>

                        <section className='Section3Presupuesto'>

                            {pdf_color_formato ?
                                <h1
                                    className='ColorTitleDocument TitleSection2'
                                    style={{
                                        borderBottom: pdf_color_formato ? `2px solid ${pdf_color_formato}` : '2px solid var(--primary-color)',
                                        paddingBottom: '5px',
                                        fontWeight: '600',
                                        marginTop: '7px'
                                    }}
                                >CONDICIONES</h1>
                                :
                                <h1 className='ColorTitleDocument TitleSection2 TitleSection3'>CONDICIONES</h1>
                            }

                            <section>
                                <div className='ObservacionesPpto2'>
                                    <div className='d-flex align-items-center'>
                                        <p>Moneda: </p>
                                        <p style={{ textTransform: 'uppercase', fontSize: '11px' }}>{moneda || '--'}</p>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <p>Forma de pago: </p>
                                        <p style={{ textTransform: 'uppercase', fontSize: '11px' }}>{forma_pago || '--'}</p>
                                    </div>
                                    {(fecha_vencimiento && fecha_vencimiento !== '') &&
                                        <div className='d-flex align-items-center'>
                                            <p>Fecha vencimiento: </p>
                                            <p style={{ fontSize: '11px' }}>{moment(fecha_vencimiento).format('DD-MM-YYYY') || '--'}</p>
                                        </div>
                                    }

                                    {(observaciones && observaciones !== '') &&
                                        <div className='block-obs'>
                                            <p>Observaciones: </p>
                                            <p className='block-obs-text'>{observaciones}</p>
                                        </div>
                                    }

                                    {(no_incluye && no_incluye !== '') &&
                                        <div className='block-obs'>
                                            <p>No Incluye: </p>
                                            <p className='block-obs-text'>{no_incluye}</p>
                                        </div>
                                    }

                                    {(terminos_condiciones && terminos_condiciones !== '' && !ppto_ocultar_tc) &&
                                        <div className='block-obs'>
                                            <p className='block-obs-label'>Términos y condiciones: </p>
                                            <p className='block-obs-text'>{terminos_condiciones}</p>
                                        </div>
                                    }

                                </div>
                            </section>
                        </section>

                        <DatosEmpresa
                            infoEmp={infoEmp}
                            infoGeneral={infoGeneral}
                        />

                        {(ppto_pdf_mostrar_firma && viewOptions.mostrar_firma) &&
                            <div className='mt-5'>
                                <div className=''>
                                    <img className='w-[100px] h-auto mb-[-55px]' src={imgFirma} alt="firma"
                                        style={{ marginLeft: '10px' }}
                                        onClick={() => (setOpenPreviewOptions(!openPreviewOptions))}
                                    />
                                    - - - - - - - - - - - - - - - - - - - - - - - - -
                                </div>
                                <div className="font-extrabold text-[12px]">ARQ DIANA BEJARANO PEÑA</div>
                                <div className='text-[10px]'>GERENTE GENERAL</div>
                            </div>
                        }


                    </div>
                </DialogContent>

                {(validacion_estado !== 'por validar' && validacion_estado !== 'rechazada') &&
                    <DialogActions className='DialogActionVistaPrevia'>
                        <Button
                            className='p-btn-secondary'
                            variant="contained"
                            size='medium'
                            type='button'
                            onClick={handleDowload}
                        >
                            {progressDownload ? <CircularProgress className='CircularProgress' /> : 'Descargar'}
                        </Button>

                        <Button
                            className='p-btn-primary'
                            variant="contained"
                            size='medium'
                            type='button'
                            onClick={handlePrint}
                        >
                            {progressPrint ? <CircularProgress className='CircularProgress' /> : 'Imprimir'}
                        </Button>

                    </DialogActions>
                }

                {openPrint &&
                    <VistaPreviaPrint
                        auth={auth}
                        infoEmp={infoEmp}
                        dataPreview={dataPreview}
                        viewOptions={viewOptions}
                        open={openPrint}
                        setOpen={setOpenPrint}
                        urlLogo={url_foto}
                        nombre_columna_dias={nombre_columna_dias}
                        infoGeneral={infoGeneral}
                        urlPDF={urlPDF}
                        imgFirma={imgFirma}
                    />
                }

                <div style={{ display: 'none' }}>
                    <PDFDownloadLink
                        document={
                            <PdfFile
                                auth={auth}
                                infoEmp={infoEmp}
                                dataPreview={dataPreview}
                                viewOptions={viewOptions}
                                urlLogo={url_foto}
                                nombre_columna_dias={nombre_columna_dias}
                                infoGeneral={infoGeneral}
                                imgFirma={imgFirma}
                            />
                        }
                        fileName={fileNamePdf}
                    >
                        <button id="btn-descargar-pdf" type="button">descargar</button>
                    </PDFDownloadLink>
                </div>

            </Dialog>
        </div >
    );
}

export default VistaPrevia

const TablaPresupuesto = ({ dataPreview, viewOptions, nombre_columna_dias }) => {

    const { separacion_miles, separacion_decimales, simbolo, nombre_columna_dias: columnName } = dataPreview
    const { pdf_color_formato, ppto_items_ocultar_dias, ppto_items_ocultar_dscto, ppto_cant_decimales } = useSelector(state => state.general.detail)

    return (
        <table className="table table-vista-previa">
            <thead>
                <tr
                    className='text-center'
                    style={{
                        borderBottom: (pdf_color_formato ? `2px solid ${pdf_color_formato}` : '2px solid var(--primary-color)')
                    }}
                >
                    <th scope="col" className='text-start w-[50%]'>Ítems</th>
                    {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos)) && <th scope="col">Cant.</th>}
                    {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !ppto_items_ocultar_dias) && <th scope="col">{columnName || 'Días'}</th>}
                    {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !viewOptions.ver_solo_titulos) && <th scope="col">Unid</th>}
                    {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos)) && <th scope="col" className='text-end'>P. Unitario</th>}
                    {!viewOptions.ocultar_montos_items && <th scope="col" className='text-end'>Subtotal</th>}

                    {(!viewOptions.ocultar_montos_items && (viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !ppto_items_ocultar_dscto) && <th scope="col" className='text-end'>Dscto.</th>}
                    {(!viewOptions.ocultar_montos_items && !ppto_items_ocultar_dscto) && <th scope="col" className='text-end'>Total</th>}
                </tr>
            </thead>
            <tbody>
                {dataPreview?.items?.filter(ti => ti.ocultar_item_print !== true)?.map((title, index) => {
                    return (
                        <>
                            <tr><td colSpan={6}></td></tr>
                            <tr className='text-center title' key={title.id}>
                                <td className='text-start'>
                                    <div className="p-vp-item-name flex">
                                        <label>{index + 1}.</label>
                                        <label style={{ marginLeft: '15px', fontSize: '11px' }}>{title.nombre}</label>
                                    </div>
                                </td>
                                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos)) && <td></td>}
                                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !ppto_items_ocultar_dias) && <td></td>}
                                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !viewOptions.ver_solo_titulos) && <td></td>}

                                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos)) &&
                                    <td className='text-end'>
                                        {/* <NumberFormat
                                            value={title.precio_unitario || 0}
                                            displayType={'text'}
                                            thousandSeparator={separacion_miles}
                                            decimalSeparator={separacion_decimales}
                                            prefix={`${simbolo} `}
                                        /> */}
                                    </td>
                                }
                                {(!viewOptions.ocultar_montos_items && !ppto_items_ocultar_dscto) &&
                                    <td className='text-end'>
                                        <NumberFormat
                                            value={title.pre_subtotal_precio || 0}
                                            displayType={'text'}
                                            thousandSeparator={separacion_miles}
                                            decimalSeparator={separacion_decimales}
                                            prefix={`${simbolo} `}
                                            decimalScale={2}
                                            fixedDecimalScale
                                        />
                                    </td>
                                }

                                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !ppto_items_ocultar_dscto) &&
                                    <td className='text-end'>
                                        <NumberFormat
                                            value={title.descuento || 0}
                                            displayType={'text'}
                                            thousandSeparator={separacion_miles}
                                            decimalSeparator={separacion_decimales}
                                            prefix={`${simbolo} `}
                                            decimalScale={2}
                                            fixedDecimalScale
                                        />
                                    </td>
                                }
                                {!viewOptions.ocultar_montos_items &&
                                    <td className='text-end'>
                                        <NumberFormat
                                            value={title.precio_subtotal || 0}
                                            displayType={'text'}
                                            thousandSeparator={separacion_miles}
                                            decimalSeparator={separacion_decimales}
                                            prefix={`${simbolo} `}
                                            decimalScale={2}
                                            fixedDecimalScale
                                        />
                                    </td>
                                }

                            </tr>

                            {/* descripcion larga tittulo */}
                            {(title.descripcion_larga && title.descripcion_larga !== '') ?
                                <tr>
                                    <td>
                                        <p className="p-vp-title-descripcion-larga">{title.descripcion_larga}</p>
                                    </td>
                                </tr> : ''
                            }

                            {title.items?.filter(it => it.ocultar_item_print !== true)?.map((item, index2) => (
                                <tr key={index2} className='text-center' style={{ display: viewOptions.ver_solo_titulos ? 'none' : '' }}>

                                    <td className='text-start'>
                                        <div className="p-vp-item-name flex ms-1">
                                            <label>{(index + 1)}.{index2 + 1}.</label>
                                            <label style={{ marginLeft: '15px', fontSize: '11px' }}>{item.nombre}</label>
                                        </div>
                                        {(item.descripcion_larga && item.descripcion_larga !== '') &&
                                            <p className="p-vp-item-descripcion-larga">
                                                {item.descripcion_larga}
                                            </p>
                                        }
                                        {(item.fecha_inicio) &&
                                            <div className="p-vp-item-descripcion-larga" style={{ fontSize: '12px' }}>
                                                <span>F. Inicio: {moment(item.fecha_inicio).format('DD-MM-YYYY')}</span>
                                                <span style={{ marginLeft: '10px' }}> F. Término: {moment(item.fecha_fin).format('DD-MM-YYYY')}</span>
                                            </div>
                                        }
                                    </td>

                                    {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos)) && <td className='p-vp-numbers'><span>{item.cant}</span></td>}
                                    {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !ppto_items_ocultar_dias) && <td className='p-vp-numbers'><span>{item.dias}</span></td>}
                                    {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !viewOptions.ver_solo_titulos) && <td className='p-vp-numbers'><span>{item.unidad_medida}</span></td>}

                                    {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos)) &&
                                        <td className='text-end p-vp-numbers'>
                                            <NumberFormat
                                                value={item.precio_unitario || 0}
                                                displayType={'text'}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                decimalScale={ppto_cant_decimales || 2}
                                                fixedDecimalScale
                                            />
                                        </td>
                                    }
                                    {(!viewOptions.ocultar_montos_items && !ppto_items_ocultar_dscto) &&
                                        <td className='text-end p-vp-numbers'>
                                            <NumberFormat
                                                value={item.pre_subtotal_precio || 0}
                                                displayType={'text'}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </td>
                                    }

                                    {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !ppto_items_ocultar_dscto) &&
                                        <td className='text-end p-vp-numbers'>
                                            <NumberFormat
                                                value={item.descuento || 0}
                                                displayType={'text'}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                decimalScale={ppto_cant_decimales || 2}
                                                fixedDecimalScale
                                            />
                                        </td>
                                    }
                                    {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_titulos) &&
                                        <td className='text-end p-vp-numbers'>
                                            <NumberFormat
                                                value={item.precio_subtotal || 0}
                                                displayType={'text'}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </td>
                                    }

                                </tr>
                            ))}
                        </>
                    )
                })}
            </tbody>
        </table >
    )
}

const PreviewOptions = ({ viewOptions, setViewOptions, imp_venta_nombre, ppto_pdf_mostrar_firma = false }) => {

    const {
        ocultar_montos_items,
        ver_solo_subtotal_item,
        ver_solo_titulos,
        ver_total_con_impuestos,
        ocultar_texto_igv,
        mostrar_firma,
        ver_solo_subtotal_titulos
    } = viewOptions

    return (
        <div className='row' style={{ borderBottom: '1px solid lightgray', marginTop: '-25px', marginBottom: '10px' }}>
            <div className='col-4'>
                <FormControlLabel
                    className='formControFilterList'
                    control={
                        <Checkbox
                            checked={ocultar_montos_items}
                            disabled={ver_solo_subtotal_item ? true : false}
                            onChange={({ target }) => (setViewOptions({
                                ...viewOptions,
                                ocultar_montos_items: target.checked
                            }))}
                            name="ocultar_montos_items"
                            color='secondary'
                        />
                    }
                    label="Ocultar montos en ítems"
                />
            </div>
            <div className='col-4'>
                <FormControlLabel
                    className='formControFilterList'
                    control={
                        <Checkbox
                            checked={ver_solo_subtotal_item}
                            disabled={ocultar_montos_items ? true : false}
                            onChange={({ target }) => (setViewOptions({
                                ...viewOptions,
                                ver_solo_subtotal_item: target.checked
                            }))}
                            name="ver_solo_subtotal_item"
                            color='secondary'
                        />
                    }
                    label="Ver solo subtotal en item"
                />
            </div>
            <div className='col-4'>
                <FormControlLabel
                    className='formControFilterList'
                    control={
                        <Checkbox
                            checked={ver_solo_subtotal_titulos}
                            disabled={ocultar_montos_items ? true : false}
                            onChange={({ target }) => (setViewOptions({
                                ...viewOptions,
                                ver_solo_subtotal_titulos: target.checked
                            }))}
                            name="ver_solo_subtotal_titulos"
                            color='secondary'
                        />
                    }
                    label="Ver solo subtotal en títulos"
                />
            </div>
            <div className='col-4'>
                <FormControlLabel
                    className='formControFilterList'
                    control={
                        <Checkbox
                            checked={ver_solo_titulos}
                            onChange={({ target }) => (setViewOptions({
                                ...viewOptions,
                                ver_solo_titulos: target.checked
                            }))}
                            name="ocultar_montos_items"
                            color='secondary'
                        />
                    }
                    label="Ver solo títulos"
                />
            </div>
            <div className='col-4'>
                <FormControlLabel
                    className='formControFilterList'
                    control={
                        <Checkbox
                            checked={ver_total_con_impuestos}
                            onChange={({ target }) => (setViewOptions({
                                ...viewOptions,
                                ver_total_con_impuestos: target.checked,
                                ocultar_texto_igv: false
                            }))}
                            name="ver_total_con_impuestos"
                            color='secondary'
                        />
                    }
                    label="Ver total con impuestos"
                />
            </div>
            <div className='col-4'>
                <FormControlLabel
                    className='formControFilterList'
                    control={
                        <Checkbox
                            checked={ocultar_texto_igv}
                            disabled={ver_total_con_impuestos ? true : false}
                            onChange={({ target }) => (setViewOptions({
                                ...viewOptions,
                                ocultar_texto_igv: target.checked
                            }))}
                            name="ocultar_texto_igv"
                            color='secondary'
                        />
                    }
                    label={`Ocultar, no incluye ${imp_venta_nombre?.toUpperCase() || 'IGV'}`}
                />
            </div>

            {ppto_pdf_mostrar_firma ?
                <div className='col-4'>
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={mostrar_firma}
                                onChange={({ target }) => (setViewOptions({
                                    ...viewOptions,
                                    mostrar_firma: target.checked
                                }))}
                                name="mostrar_firma"
                                color='secondary'
                            />
                        }
                        label="Mostrar firma"
                    />
                </div> : ''
            }

        </div>
    )
}

const DatosEmpresa = ({ infoEmp, infoGeneral }) => {

    const { pdf_color_formato } = infoGeneral
    const { razon_social, ruc, direccion, fono, sitio_web } = infoEmp

    return (
        <section className='Section4Presupuesto mt-4'>

            {pdf_color_formato ?
                <h1
                    className='ColorTitleDocument TitleSection2'
                    style={{
                        borderBottom: pdf_color_formato ? `2px solid ${pdf_color_formato}` : '2px solid var(--primary-color)',
                        paddingBottom: '5px',
                        fontWeight: '600',
                        marginTop: '7px'
                    }}
                >DATOS DE EMPRESA</h1>
                :
                <h1 className='ColorTitleDocument TitleSection2 TitleSection4'>DATOS DE EMPRESA</h1>
            }

            <section>
                <div className='DatosEmpresa'>
                    <div>
                        <p>Razón social: </p>
                        <p>{razon_social || '--'}</p>
                    </div>
                    <div>
                        <p>RUC: </p>
                        <p>{ruc || '--'}</p>
                    </div>
                    <div>
                        <p>Dirección: </p>
                        <p>{direccion || '--'}</p>
                    </div>
                    <div>
                        <p>Teléfono: </p>
                        <p>{fono || '--'}</p>
                    </div>
                    <div>
                        <p>Página web: </p>
                        <p style={{ textTransform: 'uppercase' }}>{sitio_web || '--'}</p>
                    </div>
                </div>
            </section>

        </section>

    )
}

const DatosClientes = ({ dataPreview, auth, infoGeneral }) => {

    const { ppto_pdf_ocultar_enviado_por = false } = infoGeneral

    return (
        <div className='cliente-pdf'>
            <div>
                <p className='label'>Cliente: </p>
                <p className='data'>{dataPreview?.razon_social || (dataPreview?.cliente || '--')}</p>
            </div>

            {parseInt(dataPreview?.contacto_id) > 0 &&
                <div>
                    <p className='label'>Para: </p>
                    <p className='data'>{dataPreview?.contacto_nombre || '--'}</p>
                </div>
            }

            {(dataPreview?.contacto_email && dataPreview?.contacto_email !== '') &&
                <div>
                    <p className='label'>Email: </p>
                    <p className='data'>{dataPreview?.contacto_email || '--'}</p>
                </div>
            }

            {!ppto_pdf_ocultar_enviado_por &&
                <div>
                    <p className='label'>Enviado por: </p>
                    {(auth.alias !== '' && auth.alias !== null && auth.alias_mostrar === true) ?
                        <p className='data_'>{`${auth.alias || '--'} / ${auth.email || '--'}`}</p>
                        :
                        <p className='data'>{`${auth.name || '--'} / ${auth.email || '--'}`}</p>
                    }
                </div>
            }

        </div>
    )
}
